import React from 'react';
import { ModalStyled, PrimaryButton, SecondaryButton, Footer, Header, Body } from './styles';
import dangerIcon from '@/assets/icons/danger.svg';
import { Image } from 'antd';

interface ModalProps {
    open: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    children: React.ReactNode;
    primaryButton?: {
        style: React.CSSProperties,
        text: string;
        exists_text?: string;
        exists_style?: React.CSSProperties;
    };
    secondaryButton?: {
        style: React.CSSProperties,
        text: string;
        exists_text?: string;
        exists_style?: React.CSSProperties;
    };
    exists?: boolean | { exists: boolean;[key: string]: any };
}

const DANGER_ICON = dangerIcon;

export function ModalSandbox({ open, onCancel, onConfirm, children, primaryButton, secondaryButton, exists }: ModalProps) {
    const textSecondaryButton = (typeof exists === 'boolean' ? exists : exists?.exists) && secondaryButton?.exists_text ? secondaryButton?.exists_text : secondaryButton?.text;
    const textPrimaryButton = (typeof exists === 'boolean' ? exists : exists?.exists) && primaryButton?.exists_text ? primaryButton?.exists_text : primaryButton?.text;
    const stylePrimaryButton = (typeof exists === 'boolean' ? exists : exists?.exists) && primaryButton?.exists_style ? primaryButton?.exists_style : primaryButton?.style;
    const styleSecondaryButton = (typeof exists === 'boolean' ? exists : exists?.exists) && secondaryButton?.exists_style ? secondaryButton?.exists_style : secondaryButton?.style;

    return (
        <ModalStyled open={open} onCancel={onCancel} onOk={onConfirm} footer={null} style={{ alignSelf: 'center' }}>
            <Header>
                <Image src={DANGER_ICON} alt="danger" />
            </Header>
            <Body>
                {children}
            </Body>
            <Footer>
                <SecondaryButton onClick={onCancel} style={styleSecondaryButton}>{textSecondaryButton}</SecondaryButton>
                <PrimaryButton onClick={onConfirm} style={stylePrimaryButton}>{textPrimaryButton}</PrimaryButton>
            </Footer>
        </ModalStyled>
    );
}